class EventListener {
  listeners = {};
  on(name, fn) {
    if (!Array.isArray(this.listeners[name])) {
      this.listeners[name] = [];
    }
    this.listeners[name].push(fn);
  }
  removeListener(name, fn) {
    if (Array.isArray(this.listeners[name])) {
      this.listeners[name] = this.listeners[name].filter((i) => i !== fn);
    }
  }
  removeAllListener(name) {
    if (name) {
      Reflect.deleteProperty(this.listeners, name);
    } else {
      this.listeners = {};
    }
  }
  emit(name, ...args) {
    if (Array.isArray(this.listeners[name])) {
      this.listeners[name].forEach((fn) => fn(...args));
    }
  }
}

export const eventNames = {
  userGroupRolePermissionChange: 'userGroupRolePermissionChange',
  pwcTeamRolePermissionChange: 'pwcTeamRolePermissionChange',
  // removeUser: 'removeUser',
  // addUser: 'removeUser',
  userChange: 'userChange',
  groupChange: 'groupChange',
  groupClientChange: 'groupClientChange',
};

export const eventDataType = {
  update: 'update',
  add: 'add',
  delete: 'delete',
  edit: 'edit',
};

export default EventListener;
